import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { DettaglioLineePAModalComponent } from './dettaglio-linee-pa-modal';

export const DettaglioLineePAModalModule: string = ng
    .module('dettaglio-linee-pa-moda', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('dettaglioLineePAModalComponent', DettaglioLineePAModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/fatturazione/fatturazione-pa/dettaglio-linee-pa-modal/dettaglio-linee-pa-modal.module.ts